export const EMAIL_GROUPS = [
  {
    name: "AUCN_SALES",
    requesters: [
      "wenqif@gomarkets.com",
      "williamz@gomarkets.com",
      "shihaol@gomarkets.com",
      "conniel@gomarkets.com",
      "jiachenl@gomarkets.com",
      "yoriy@gomarkets.com",
      "mikem@gomarkets.com",
      "cheryll@gomarkets.com",
      "jingxiangl@gomarkets.com",
      "oliverx@gomarkets.com",
      "flackoz@gomarkets.com",
      "esmel@gomarkets.com",
    ],
    approvers: ["yez@gomarkets.com"],
  },
  {
    name: "GLOBAL_SALES",
    requesters: [
      "lachlanm@gomarkets.com",
      "beng@gomarkets.com",
      "victore@gomarkets.com",
      "yez@gomarkets.com",
      "gordonw@gomarkets.com",
      "jasonz@gomarkets.com",
      "karleec@gomarkets.com",
      "angelac@gomarkets.com",
      "klavsv@gomarkets.com",
      "yaazdeej@gomarkets.com",
    ],
    approvers: ["mikeh@gomarkets.com"],
  },
];
